<template>
  <div class="solutions">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <h1>解决方案</h1>
          <p>为您提供全场景AI解决方案 智能解决您遇到的问题</p>
        </div>
        <div class="hero-image">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/top.png" alt="AI解决方案" class="ai-character" />
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <div class="content-wrapper">
        <!-- Left Navigation Sidebar -->
        <div class="sidebar">
          <div class="nav-item" :class="{ active: activeNavItem === 1 }" @click="scrollToService('service-1')">
            <span>数字人形象定制服务</span>
          </div>
          <div class="nav-item" :class="{ active: activeNavItem === 2 }" @click="scrollToService('service-2')">
            <span>数字人短视频创作系统</span>
          </div>
          <div class="nav-item" :class="{ active: activeNavItem === 3 }" @click="scrollToService('service-3')">
            <span>数字人交互系统</span>
          </div>
          <div class="nav-item" :class="{ active: activeNavItem === 4 }" @click="scrollToService('service-4')">
            <span>AI屏形机器人</span>
          </div>
          <div class="nav-item" :class="{ active: activeNavItem === 5 }" @click="scrollToService('service-5')">
            <span>AI秘书</span>
          </div>
          <div class="nav-item" :class="{ active: activeNavItem === 6 }" @click="scrollToService('service-6')">
            <span>AIGC视频制作服务</span>
          </div>
        </div>

        <!-- Right Content Area -->
        <div class="content-area">
          <!-- Solution Categories -->
          <div class="solution-categories">
            <div 
              v-for="(category, index) in categories" 
              :key="category.id"
              class="category-card"
              :class="{ active: activeCategoryIndex === index }"
              @click="selectCategory(index)"
            >
              <div class="category-image">
                <img :src="category.image" :alt="category.name" />
              </div>
              <div class="category-content">
                <h3>{{ category.name }}</h3>
                <div class="category-number">{{ category.number }}</div>
              </div>
            </div>
          </div>

          <!-- Detailed Solution Section -->
          <div class="detailed-solution">
            <h2 class="solution-title">{{ currentSolution.title }}</h2>
            <p class="solution-intro">
              {{ currentSolution.intro }}
            </p>

            <div class="solution-services">
              <div class="service-item" v-for="(service, index) in currentSolution.services" :key="service.title" :id="getServiceId(service.title)">
                <h3>{{ service.title }}</h3>
                <div v-if="Array.isArray(service.description)" class="service-description-array">
                  <p v-for="(desc, index) in service.description" :key="index">{{ desc }}</p>
                </div>
                <p v-else>{{ service.description }}</p>
                
                <!-- 显示 description2 如果存在 -->
                <div v-if="service.description2 && Array.isArray(service.description2)" class="service-description-array">
                  <p v-for="(desc, index) in service.description2" :key="'desc2-' + index">{{ desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Solutions',
  data() {
    return {
      activeCategoryIndex: 0, // AI博物馆 is active by default
      activeNavItem: 1, // 当前激活的导航项
      categories: [
        {
          id: 1,
          name: 'AI政务',
          image: require('@/assets/image/solution/1.png'),
          number: '智能导办咨询｜政策语音解读'
        },
        {
          id: 2,
          name: 'AI文旅',
          image: require('@/assets/image/solution/2.png'),
          number: '虚拟导览讲解｜数字文化传播'
        },
        {
          id: 3,
          name: 'AI银行',
          image: require('@/assets/image/solution/3.png'),
          number: '智能迎宾服务｜理财讲解顾问'
        },
        {
          id: 4,
          name: 'AI医院',
          image: require('@/assets/image/solution/4.png'),
          number: '分诊导医助手｜健康问答咨询'
        },
        {
          id: 5,
          name: 'AI博物馆',
          image: require('@/assets/image/solution/5.png'),
          number: '展品故事复现｜虚拟交互体验'
        },
        {
          id: 6,
          name: 'AI商场',
          image: require('@/assets/image/solution/6.png'),
          number: '品牌互动展示｜智慧零售体验'
        }
      ],
      solutions: {
        1: {
          title: 'AI政务-整体解决方案',
          intro: '在国家持续推进数字政府建设的背景下，各地政府正积极探索如何借助前沿科技提升政务服务能力。随着“互联网+政务服务”的深入发展，公众对政务服务的便捷性、智能化、个性化提出了更高要求。在信息深度共享和业务深度协同的基础上，我们广泛应用AI数字人等技术，旨在构建全天候、无障碍的智慧政务服务体系。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：定制不同部门(如税务局、社保局、民政局等)的数字政务形象，可选择真人复刻或卡通风格，统一着装，展现亲民、专业的政府形象。这些数字人不仅代表政府部门，更是政务服务品牌的形象大使，让公众感受到科技带来的便利与温度。'
            },
            {
              title: '数字人短视频创作',
              description: '应用： 利用数字人IP制作各类政策解读、办事流程指南、常见问题解答的短视频，如针对高频业务如“新生儿落户”“医保报销流程”等系列微短剧或动画，通过生动直观的视频形式，提高政策普及率，减少公众办事前的疑惑，减轻窗口人员压力。'
            },
            {
              title: '智能审批系统',
              description: '应用：结合AI技术优化审批流程，提供智能预审、材料检查、进度查询等服务，提升审批效率，改善市民办事体验。'
            },
            {
              title: '数字人交互系统',
              description: [
                '线上：在政务服务官网、APP、微信公众号等平台部署数字人智能客服，24小时在线解答公众咨询，提供智能问答、业务预审、材料清单生成、预约办理等服务，有效分流人工客服压力。',
                '线下：于政务大厅、社区服务中心设置数字交互大屏，提供语音交互、触摸查询服务，引导市民取号、前往指定窗口，播放政策宣传片、办理进度查询，实现政务服务全天候响应，让市民办事更加省心、省力。'
              ]
            },
            {
              title: 'AI屏形机器人',
              description: '应用：超写实3D政务数字人，可置于政务大厅内，主动唤醒识别并提供移动导览、业务咨询等相关服务，可根据市民的语言偏好提供多语种服务，提升客户服务体验。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助政务工作人员进行各类会议(如部门例会、政策研讨会、专家论证会)的记录、政策文件起草、信访材料整理等工作。',
              description2: [
                '录音/音频转写：将会议、采访内容快速转写成文字，并自动区分发言人。',
                '总结与思维导图:自动提炼会议要点，生成结构化的会议纪要或思维导图，大幅提升文件整理效率。',
                '多语种:支持多语种的转写和总结，便于涉外政务交流与合作。'
              ],
            },
            {
              title: 'AIGC视频制作服务',
              description: '应用：制作政务场景宣传片、重大项目介绍片、区域发展规划片、基层治理经验分享等。可结合实景拍摄与虚拟数字人解说、瞬息特效等技术，通过AIGC一键打造更具创意和冲击力的宣传内容。'
            },
          ]
        },
        2: {
          title: 'AI文旅-整体解决方案',
          intro: '随着文化和旅游深度融合，游客对旅游体验的需求从“走马观花”转向“深度沉浸”，对个性化、智能化服务的要求越来越高。在“智慧旅游”和“文化数字化”战略指引下，各大文旅景区正积极寻求技术创新，以提升服务品质，丰富文化内涵，拓宽传播渠道。我们借助AI数字人、智能交互系统等技术，旨在为游客提供更智能、更便捷、更富沉浸感的文旅体验。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：定制具有地域特色(如民族服饰)、历史人物(如景区相关历史名人)、神话传说形象(如西湖的"白娘子")的数字导游、讲解员IP形象作为景区的"文化符号"。'
            },
            {
              title: '数字人短视频创作',
              description: '应用：结合数字人IP形象批量生成景区介绍、景点讲解、游览路线推荐、特色活动预告、文化故事分享等短视频。例如,数字导游讲解"黄鹤楼的历史典故"并结合3D动画还原场景,通过数字人讲解等方式帮助游客快速了解当地非遗文化技艺。'
            },
            {
              title: '数字人交互系统',
              description: '应用：·线上：在景区官网、APP、微信小程序、抖音等渠道部署数字人客服,24小时在线解答游客关于门票购买、交通路线、餐饮住宿、周边景点等问题,提供实时导览、游玩攻略、紧急救援等信息。·线下：在游客中心、重要景点、休憩区放置数字人交互大屏,提供语音交互、触摸查询、多语种讲解、路线规划、AI拍照换装等功能,24小时响应游客需求,解决游览中的各种问题。'
            },
            {
              title: 'AI屏形机器人',
              description: '应用：应用于景区内重点区域,为游客提供个性化导览服务,讲解景点历史文化,推荐游览路线,提供更智能、更生动的景区导览新方式,有效分流人工讲解压力。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助景区管理人员进行会议记录、游客意见收集与分析、市场调研报告撰写、文化项目策划、国际交流合作等工作。',
              description2: [
                '录音/音频转写：将游客反馈、专家讲座、内部会议等音频内容快速转写成文字,并进行情感分析。',
                '总结与思维导图：自动提炼核心信息,生成报告或策划方案,辅助景区运营决策。',
                '多语种：支持多语种处理,便于接待国际游客和开展国际合作。'
              ]
            },
            {
              title: 'AIGC视频制作服务',
              description: '应用：制作高品质的景区宣传片、季节性活动推广片、文化遗产纪录片、旅游线路定制宣传片等。可将特色景观与虚拟特效、数字人讲解、历史场景重现相结合,打造震撼的视觉效果,实现"未游先知,未临先感"。'
            }
          ]
        },
        3: {
          title: 'AI银行-整体解决方案',
          intro: '随着金融科技的快速发展，银行业正积极拥抱数字化转型，AI技术为银行服务带来了革命性的变化。通过智能化的解决方案，银行可以为客户提供更便捷、更安全的金融服务，同时提升运营效率和风险控制能力。我们借助AI数字人、智能交互系统等技术，旨在构建全场景智慧金融服务新范式。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：为银行定制数字大堂经理、理财顾问、信贷专员等数字人形象，用户可选择商务正装等专业风格，与银行VI系统融合，展现专业、科技、品牌调性。数字人可根据不同业务场景切换形象风格。'
            },
            {
              title: '数字人短视频创作',
              description: '应用：制作各类金融产品介绍(如基金、保险、信用卡)、业务办理指南(如开户、转账)、防诈骗提醒、金融知识普及、银行品牌推广等短视频。例如，数字理财顾问讲解"如何选择适合的基金产品"通过动画视频，让金融知识通俗易懂。'
            },
            {
              title: '数字人交互系统',
              description: ['线上：在手机银行APP、微信公众号、小程序等平台部署数字人智能客服，24小时在线客户咨询、业务查询、预约办理、贷款预评估，提供个性化金融产品推荐，实现"千人千面"精准服务。',
              '线下：在银行大厅、VIP客户区设置数字人大屏，提供语音交互、触摸查询、业务引导、金融产品展示、汇率查询、自助交易等功能，数字人辅助人工客服，分流柜台压力，提升网点智能化水平。']
            },
            {
              title: 'AI屏形机器人',
              description: '应用：放置于营业大厅，为客户提供更主动、智能的线下服务，提升客户体验，减少客户等待时间，引导业务办理，精准捕捉客户画像，实现垂直化产品营销推荐。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助银行客户经理、理财顾问、风控人员等进行客户访谈、业务会议、市场分析、合规审查等工作。',
              description2: [
                '录音/音频转写：将客户访谈、电话沟通、内部会议内容转写成文字，进行情感识别和关键信息提取。',
                '总结与思维导图：自动提炼客户需求和会议要点，生成客户画像、业务报告、风险评估报告，辅助决策。',
                '多语种：支持多语种处理，便于服务国际客户和跨境金融业务。'
              ]
            },
            {
              title: 'AIGC视频制作服务',
              description: '应用：制作银行宣传片、金融知识普及视频、投资教育视频等。结合虚拟技术和动效，展现银行创新理念和服务理念，打造专业权威的金融品牌内容。'
            }
          ]
        },
        4: {
          title: 'AI医院-整体解决方案',
          intro: '随着人口老龄化加速和健康中国战略的深入实施，公众对医疗服务的需求日益增长，对就医体验、医疗效率、健康管理提出了更高要求。在“智慧医疗”建设的推动下，医院正积极探索利用人工智能技术优化服务流程、提升诊疗效率、普及健康知识。我们通过AI数字人、智能交互系统等技术，旨在构建以患者为中心、线上线下融合的智慧医疗服务新模式。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：定制医院专属的数字导诊、医生、护士形象，结合医院文化和不同科室特点，展现医院的关怀与专业性。例如，儿科可定制卡通数字人，肿瘤科可定制稳重专业的数字医生。'
            },
            {
              title: '数字人短视频创作',
              description: '应用：制作各类科室介绍、疾病科普（如"日常眼部护理"、"高血压的预防"）、就医流程指导（如"如何办理住院手续"）、健康宣教、术前宣教、用药指导的短视频。通过AI数字医生结合动画进行演示讲解，更易于患者理解。'
            },
            {
              title: '数字人交互系统',
              description: ['线上：在医院官网、手机APP、微信公众号等平台部署数字人智能客服，24小时在线解答患者关于挂号、科室、医生、检查报告、医保政策等咨询，提供预约挂号、智能导诊（根据症状推荐科室）、用药提醒、复诊提醒等服务。',
              '线下：在门诊大厅、各科室门口、住院部、候诊区等区域设置数字人交互大屏，提供语音交互、触摸查询、科室导航、排队叫号、检查报告自助打印，提升患者就医效率。'
            ]
            },
            {
              title: 'AI屏形机器人',
              description: '应用：在就医流程办理点位（如医院大厅、住院部）等区域巡逻，主动识别患者并提供路线指引、科室介绍、健康咨询、药房导航，能进行简单的心理安抚和情感陪伴。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助医护人员进行查房记录、病例讨论、学术会议、患者访谈、手术记录等工作。',
              description2: [
                '录音/音频转写：将查房、病例讨论、患者问诊、手术过程内容快速转写成文字，并自动识别医学术语。',
                '总结与思维导图：自动提炼关键信息，生成病历摘要、会议纪要、手术报告等，辅助临床决策和教学科研。',
                '多语种：支持多语种处理，便于服务外国患者及国际学术交流的开展。'
              ],
            },
            
            {
              title: 'AIGC视频制作服务',
              description: '应用：以AIGC视频动效辅助制作医院宣传片、特色科室介绍片、医学前沿技术展示等。运用3D建模展示人体结构或手术过程，打造专业权威、生动形象的医疗宣传内容，有效提升医院品牌形象和学术影响力。'
            }
          ]
        },
        5: {
          title: 'AI博物馆-整体解决方案',
          intro: '随着公众对文化生活的需求日益增长，博物馆作为文化传承与教育的重要阵地，正积极探索数字化转型之路。博物馆亟需通过创新技术，提升展览的吸引力、讲解的生动性、文化的传播力，以更好地承担社会教育和文化传播的职责。华视借AI之力，为每一位参观者提供更丰富、更深入、更个性化的文化体验。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：定制具有历史文化背景(如历史名人、神话人物)、特定时期风格(如汉服、清宫服饰)的AI数字讲解员形象。以博物馆的"文化大使"身份,在不同展厅或专题展览中提供个性化讲解服务。'
            },
            {
              title: '数字人短视频创作',
              description: '应用：制作文物故事讲解(如"兵马俑的建造之谜"、"千里江山图的艺术魅力")、历史背景介绍、文化知识普及的短视频。通过AI数字讲解员结合3D动画,实现历史场景复现,提升参观者的文化获得感和理解度,有效进行文化知识的传播。'
            },
            {
              title: '数字人交互系统',
              description:[
              '线上：在博物馆官网、微信公众号、小程序、抖音等平台部署数字人智能客服,24小时在线解答参观者关于门票、开放时间、展览信息、交通路线、馆藏查询等咨询,提供预约讲解、个性化游览路线推荐。',
              '线下：在展厅入口、重要展品旁、休息区设置数字人大屏,提供语音交互、触摸查询、多语种讲解、展品信息深度解读等,让文化知识的获取更加便捷和有趣。'
              ],
            },
            {
              title: 'AI屏形机器人',
              description: '应用：置于展厅各馆内,为参观者提供馆内路线指引、展品讲解(如到达重要文物点位时自动触发讲解)、历史知识问答,并可根据参观者的年龄,切换不同讲解模版。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助博物馆工作人员进行学术研讨、文物鉴定、策展会议、专家访谈、观众反馈分析等工作。',
              description2: [
                '录音/音频转写：将专家讲座、研讨会、口述历史采访内容快速转写成文字,并进行语义分析。',
                '总结与思维导图：自动提炼核心观点,生成学术报告、策展方案、文物研究报告等,辅助学术研究和展览策划。',
                '多语种：支持多语种同传翻译,为促进文化交流提供有效技术支持。'
              ],
            },
            {
              title: 'AIGC视频制作服务',
              description: '应用：制作博物馆形象宣传片、特色展览预告片、文物修复过程纪录片、文化IP衍生品推广片等。可将展品与虚拟历史场景相融合,打造沉浸式的文化体验,让传统文化以更智能、更生动的方式走向大众。'
            }
          ]
        },
        6: {
          title: 'AI商场-整体解决方案',
          intro: '面对电商冲击和消费升级，传统商场正经历深刻变革，从单纯的购物场所向集购物、餐饮、娱乐、社交于一体的“体验中心”转型。在“新零售”和“智慧商圈”的趋势下，商场亟需通过数字化、智能化手段，提升顾客购物体验，优化运营管理，实现精准营销。我们通过AI交互等智能服务为商场构建一个全方位、个性化、高效便捷的智慧零售生态。',
          services: [
            {
              title: '数字人形象定制服务',
              description: '应用：定制商场专属的数字导购、形象代言人形象。结合商场定位和品牌调性,展现商场的活力与创新,数字人可根据不同节日或促销活动,更换服装和造型。'
            },
            {
              title: '数字人短视频创作',
              description: '应用：批量生成商场活动预告、品牌新品推广、优惠信息发布、购物指南、美食探店等数字人短视频。例如,"AI探店推荐官"推荐商场特色餐厅,利用短视频平台进行裂变式营销。'
            },
            {
              title: '数字人交互系统',
              description: ['线上：在商场公众号、微信小程序、抖音生活服务等平台部署数字人智能客服,24小时在线解答顾客关于品牌、活动、积分、停车、会员服务、商品查询等咨询,提供楼层导览、商品推荐、预约服务(如美妆试用、餐饮预订).', 
              '线下：在商场入口、中庭、各楼层、电梯厅设置数字人大屏,提供语音交互、触摸查询、楼层导览、品牌推荐、会员服务、AI拍照换装、停车导航等功能。']
            },
            {
              title: 'AI屏形机器人',
              description: '应用：置于商场各层,提供路线指引、品牌推荐、优惠信息告知、停车导航、活动推广等信息查询,分析顾客的消费偏好进行个性化商品/游玩项目推荐。'
            },
            {
              title: 'AI秘书',
              description: '应用：辅助商场运营人员进行招商会议、市场调研、活动策划、客户投诉处理、员工培训等工作。',
              description2: [
                '录音/音频转写：将招商洽谈、客户访谈、运营会议内容转写成文字,并进行关键词提取。',
                '总结与思维导图：自动提炼市场需求、会议要点,生成招商报告、活动方案、竞品分析报告等,辅助决策。',
                '多语种：支持多语种同传翻译,便于国际品牌洽谈工作。'
              ],
            },
            {
              title: 'AIGC视频制作服务',
              description: '应用：制作商场整体形象宣传片、节假日(如圣诞、春节)活动推广片、品牌入驻宣传片等。结合部分实景拍摄,运用AIGC技术快速生成多元化、高品质的创意内容,用于线上线下全渠道营销。'
            }
          ]
        }
      }
    }
  },
  computed: {
    currentSolution() {
      return this.solutions[this.activeCategoryIndex + 1] || this.solutions[5];
    }
  },
  methods: {
    selectCategory(index) {
      this.activeCategoryIndex = index;
    },
    // 根据服务标题获取对应的 serviceId
    getServiceId(title) {
      const serviceIdMap = {
        '数字人形象定制服务': 'service-1',
        '数字人短视频创作系统': 'service-2',
        '数字人短视频创作': 'service-2', // 兼容不同标题
        '数字人交互系统': 'service-3',
        'AI屏形机器人': 'service-4',
        'AI秘书': 'service-5',
        'SHINEBO-AI随身秘书': 'service-5', // 兼容不同标题
        'AIGC视频制作服务': 'service-6'
      };
      return serviceIdMap[title] || `service-${title}`;
    },
    scrollToService(serviceId) {
      const element = document.getElementById(serviceId);
      if (element) {
        // 更新高亮状态
        const serviceIndex = parseInt(serviceId.split('-')[1]);
        this.activeNavItem = serviceIndex;
        
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    handleScroll() {
      // 获取所有服务项
      const serviceItems = document.querySelectorAll('.service-item');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      serviceItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const elementTop = rect.top + scrollTop;
        const elementBottom = elementTop + rect.height;
        const serviceId = item.id;
        
        // 如果元素在视口中心附近，则高亮对应的导航项
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2 && serviceId) {
          const serviceIndex = parseInt(serviceId.split('-')[1]);
          if (serviceIndex) {
            this.activeNavItem = serviceIndex;
          }
        }
      });
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
    this.scrollToTop();
    
    // 检查路由参数，如果有 serviceId，则跳转到对应位置
    this.$nextTick(() => {
      const serviceId = this.$route.query.serviceId;
      if (serviceId) {
        // 延迟一下确保 DOM 已经渲染完成
        setTimeout(() => {
          this.scrollToService(serviceId);
        }, 300);
      }
    });
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    // 监听路由变化，当从其他页面跳转过来时也能处理
    '$route'(to) {
      if (to.query.serviceId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToService(to.query.serviceId);
          }, 300);
        });
      }
    }
  }
}
</script>

<style scoped>
.solutions {
  min-height: 100vh;
  background-color: #f8f9fa;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(#93BEEB 0%, #F0F7FD 100%);
  position: relative;
  overflow: hidden;
}

.hero-content {
  margin-left: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.hero-text h1 {
  color: #2c3e50;
  margin-bottom: 20px;
  width: 256px;
  height: 84px;

  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 84px;
  color: #222222;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.hero-text p {
  font-size: 1.2rem;
  color: #2c3e50;
  line-height: 1.6;
  max-width: 500px;
/* 为您提供全场景AI解决方案 智能解决您遇到的问题 */

  width: 414px;
  height: 88px;

  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 44px;
  /* or 157% */

  color: #333333;


  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}

.hero-image {
  position: relative;
  height: 400px;
}

.ai-character {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transform: scaleX(-1);
}

/* Main Content */
.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 40px;
}

/* Sidebar */
.sidebar {
  border-radius: 10px;
  padding: 20px 0;
  height: fit-content;
}

.nav-item {
  padding: 15px 20px 10px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #2c3e50;
  font-weight: 500;
}

.nav-item:hover {
  background-color: #f8f9fa;
}

.nav-item.active {
  color: #045FB2;
  border-bottom: 2px solid #045FB2;
}

/* Content Area */
.content-area {
  flex: 1;
  border-left: 1px solid #D9D9D9;
  padding: 40px 0px 120px 40px;
}

/* Solution Categories */
.solution-categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.category-card {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  padding: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 15px;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.category-card.active {
  background-color: #045FB2;
  color: white;
}

.category-image {
  flex-shrink: 0;
  width: 110px;
  overflow: hidden;
}

.category-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-content {
  flex: 1;
  text-align: left;
}

.category-content h3 {
  font-size: 1.1rem;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.category-card.active .category-content h3 {
  color: white;
}

.category-number {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 12px;
  line-height: 18px;
  color: #333333;
}

.category-card.active .category-number {
  color: white;
}

/* Detailed Solution */
.detailed-solution {
  padding: 40px;
}

.detailed-solution h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 20px;
  font-weight: 700;
}

.solution-title {
  text-align: center;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 48px;
  color: #222222;
}

.solution-intro {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 30px;
font-family: 'Microsoft YaHei';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;
color: #333333;


}

.solution-services {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.service-item h3 {
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 600;
}

.service-item p {
  font-size: 1rem;
  line-height: 1.7;
font-family: 'Microsoft YaHei';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;
/* or 175% */

color: #333333;


}

.service-description-array p {
  font-size: 1rem;
  line-height: 1.7;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #333333;
  margin-bottom: 10px;
}

.service-description-array p:last-child {
  margin-bottom: 0;
}

.service-description-array p::before {
  content: "·";
  font-weight: bold;
  margin-right: 4px;
}

.service-description-array p {
  text-indent: -1em;
  padding-left: 1em;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .solution-categories {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .category-card {
    padding: 15px;
  }
  
  .category-image {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
  }
  
  .hero-text h1 {
    font-size: 2.5rem;
  }
  
  .hero-image {
    width: 250px;
    height: 300px;
    margin-top: 30px;
  }
  
  .solution-categories {
    grid-template-columns: 1fr;
  }
  
  .category-card {
    padding: 12px;
    gap: 12px;
  }
  
  .category-image {
    width: 45px;
    height: 45px;
  }
  
  .category-content h3 {
    font-size: 1rem;
  }
  
  .category-number {
    font-size: 1.1rem;
  }
  
  .detailed-solution {
    padding: 20px;
  }
  
  .detailed-solution h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 2rem;
  }
  
  .hero-text p {
    font-size: 1rem;
  }
  
  .hero-image {
    width: 200px;
    height: 250px;
  }
}
</style>